"use client";
import Image from "next/image";
import { useState, useRef, useEffect } from "react";
import { Menu, X } from "lucide-react";
import NavBar from "./navbar";
import MobileNavBar from "./navbar/mobile";
import { useResponsive } from "@/app/hooks/useResponsive";
import { motion } from 'framer-motion'

const Header = () => {
  const { isSm } = useResponsive();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <motion.header
      className="flex flex-row max-w-7xl w-full justify-between items-center mx-auto absolute top-10 px-6"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <Image
        src="/escapa/transp/escapa_1.png"
        alt="Logo escapa!"
        height={80}
        width={200}
      />

      {isSm ? (
        <NavBar />
      ) : (
        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setIsOpen((prev) => !prev)}
            className="text-white"
            aria-label="Abrir menu de navegação"
          >
            {!isOpen && <Menu size={28} />}
          </button>

          {isOpen && (
            <div
              className="absolute top-[-54px] right-[-24px] bg-white shadow-lg rounded-bl-xl p-6 min-w-fit"
              onClick={() => setIsOpen(false)}
            >
              <X
                className="absolute right-3 top-3"
                aria-label="Fechar menu de navegação"
              />
              <MobileNavBar />
            </div>
          )}
        </div>
      )}
    </motion.header>
  );
};

export default Header;
